"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ErrorBase = _interopRequireDefault(require("./_ErrorBase"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var Forbidden = function Forbidden() {
  return /*#__PURE__*/_react.default.createElement(_ErrorBase.default
  // We want to keep backUrl as a fallback if data center is using ui-floorplans below v4.12.0
  , {
    backUrl: "javascript:history.back(-3)",
    backFn: function backFn() {
      window.history.back(-3);
    },
    type: "forbidden"
  });
};
var _default = exports.default = Forbidden;